const CryptoJS = require('crypto-js');

export const getEncryptedString = (data: any) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), '$2y$12$onMU0Fux3cpPp73ZoGEyyui9FMxLCpWMco7YLUmwCzRsgc2uVbQLe').toString();
}